function toKebabCase (str)
{
    const result = str.replace(
        /([A-Z\u00C0-\u00D6\u00D8-\u00DE])|([0-9]+)/g,
        match => '-' + match.toLowerCase()
    )
      
    return (str[0] === str[0].toUpperCase())
        ? result.substring(1)
        : result
}

function isEmptyString (str)
{
    if (str == undefined || str == null) return true

    const noSpaces = str.replace(/ /g, '')

    return noSpaces == ''
}

function isAnyEmptyString (stringsArray)
{
    for (const str of stringsArray)
    {
        if (isEmptyString(str)) return true
    }

    return false
}

function removeHtmlTags (str, escapeBrTags, specificTag)
{
    if (!escapeBrTags) escapeBrTags = false
    if (!specificTag) specificTag = ''

    if (escapeBrTags)
    {
        str = str.replace(new RegExp(`(<br ?/?>)`, 'g'), '\n')
    }

    if (!isEmptyString(specificTag))
    {
        return str.replace(new RegExp(`(</?${specificTag}>)`, 'g'), '')
    }

    return str.replace(/<[^>]*>/g, '')
}

function plural (str, number)
{
    if (Array.isArray(number)) number = number.length
    if (typeof number == 'string') number = Number.parseFloat(number)

    return str + (number > 1 ? 's' : '')
}

function isValidEmail (email)
{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    return re.test(String(email).toLowerCase());
}

export default { toKebabCase, isEmptyString, isAnyEmptyString, removeHtmlTags, plural, isValidEmail }


// WEBPACK FOOTER //
// ./src/utils/stringUtils.js